import React, { useState, useEffect } from "react";
import { Modal, Radio, Space, message } from "antd";
import Button from "../../components/common/button";
import Close from "../../assets/icons/close.svg";
import colors from "../../share/constants/constants";

const ExportCustomersModal = ({
  visible,
  onCancel,
  onExport,
  selectedCount,
  exportLoading,
}) => {
  const [exportScope, setExportScope] = useState("selected");

  const handleOk = () => {
    onExport(exportScope);
  };
  useEffect(() => {
    if (selectedCount === 0) {
      setExportScope("all");
    } else {
      setExportScope("selected");
    }
  }, [selectedCount]);

  return (
    <Modal
      open={visible}
      footer={null}
      closeIcon={null}
      width="450px"
      onCancel={onCancel}
    >
      <div className="border-2 px-2 py-2 rounded">
        <div className="flex mb-4">
          <h2 className="flex-1 text-lg font-medium">Export Customers</h2>
          <img
            src={Close}
            alt="Close"
            className="w-3.2 cursor-pointer"
            onClick={onCancel}
          />
        </div>

        <Space direction="vertical" style={{ width: "100%" }}>
          <Radio.Group
            onChange={(e) => setExportScope(e.target.value)}
            value={exportScope}
            className="w-full"
          >
            <Space direction="vertical" className="w-full">
              <Radio
                value="selected"
                disabled={selectedCount === 0}
                className="w-full"
              >
                Export selected customers ({selectedCount} selected)
              </Radio>
              <Radio value="all" className="w-full">
                Export all customers from database
              </Radio>
            </Space>
          </Radio.Group>

          {exportScope === "all" && (
            <div className="mt-4 text-gray-500">
              This will export all customer records in the database, not just
              the ones visible on this page.
            </div>
          )}
        </Space>

        <div className="flex justify-center mt-6">
          <Button
            title="Export"
            color={colors.primaryPurple}
            onClick={handleOk}
            className="w-full"
            loading={exportLoading}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ExportCustomersModal;
